import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const ownerApi = createApi({
    reducerPath: "core/owner",
    baseQuery: axiosBaseQuery,
    tagTypes: ["ownerList"],
    endpoints: (builder) =>({
        ownerFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['ownerList'],
            query: (query = '') => ({
                url: "core/owner/" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        ownerCreate: builder.mutation({
            invalidatesTags: ['ownerList'],
            query: (data)=>({url: "core/owner/", method: "POST", data})
        }),
        ownerUpdate: builder.mutation({
            invalidatesTags: ['ownerList'],
            query: (data)=>({url: "/core/owner/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        ownerDelete: builder.mutation({
            invalidatesTags: ['ownerList'],
            query: (id)=>({url: "/core/owner/"+id, method: "DELETE"})
        }),
    })
})

export const { useOwnerFindAllQuery, useOwnerCreateMutation, useOwnerUpdateMutation, useOwnerDeleteMutation } = ownerApi;
export {ownerApi};
